import {ClientJS} from "clientjs";
import {createApp} from "vue";
import App from "./comment/App.vue";

// コメント部分の描写
const commentAppArea = document.getElementById('js-comment');
if (commentAppArea) {
  const app = createApp(App);
  app.provide('columnId', commentAppArea.dataset.columnId);
  app.provide('userId', commentAppArea.dataset.userId);
  app.mount(commentAppArea);
}

document.addEventListener('DOMContentLoaded', () => {
  let pageIndex = 0;
//  ページャー
  nextPageLinkList = document.getElementsByClassName('js-nextPageLink') ?? [];
  prevPageLinkList = document.getElementsByClassName('js-prevPageLink') ?? [];
  pageLinkList = document.querySelectorAll('[id^="js-pageLink-"]') ?? [];
  pageTargetList = document.querySelectorAll('[id^="js-content-"]') ?? [];
  nextPageBtnList = document.getElementsByClassName('js-nextBtn') ?? [];
  prevPageBtnList = document.getElementsByClassName('js-prevBtn') ?? [];
  nextPageBoxList = document.querySelectorAll('[id^="js-nextPageBox-"]') ?? [];

  //次のページへボタン
  for (const next of nextPageLinkList) {
    next.addEventListener('click', () => {
      pageIndex++;

      //prevボタンを表示
      for (const btn of prevPageBtnList) {
        btn.style.display = 'list-item';
      }

      //最後のページだったらnextボタン、nextボックス非表示
      if (pageIndex === pageIndex_max) {
        for (const btn of nextPageBtnList) {
          btn.style.display = 'none';
        }
        for (const box of nextPageBoxList) {
          box.style.display = 'none';
        }
      }

      pageTargetList.forEach((page, index) => {
        page.style.display = index === pageIndex ? 'block' : 'none';
      });
    });
  }

//  前のページへボタン
  for (const prev of prevPageLinkList) {
    prev.addEventListener('click', () => {
      pageIndex--;

      //nextボタンを表示
      for (const btn of nextPageBtnList) {
        btn.style.display = 'list-item';
      }
      //nextボックスを表示
      for (const box of nextPageBoxList) {
        box.style.display = 'block';
      }

      //最初のページだったらprevボタン非表示
      if (pageIndex === 0) {
        for (const btn of prevPageBtnList) {
          btn.style.display = 'none';
        }
      }

      pageTargetList.forEach((page, index) => {
        page.style.display = index === pageIndex ? 'block' : 'none';
      });
    });
  }

//  各ページボタン
  for (const pageLink of pageLinkList) {
    pageLink.addEventListener('click', (e) => {
      const targetId = e.currentTarget.id.slice(e.currentTarget.id.lastIndexOf('-') + 1);

      pageIndex = parseInt(targetId);

      //最初のページじゃなかったらprevボタンを表示
      const nextDisplay = (pageIndex !== 0 ? 'list-item' : 'none');
      for (const btn of prevPageBtnList) {
        btn.style.display = nextDisplay;
      }

      //最後のページじゃなかったらnextボタンを表示
      const prevDisplay = (pageIndex !== pageIndex_max ? 'list-item' : 'none');
      for (const btn of nextPageBtnList) {
        btn.style.display = prevDisplay;
      }

      //最後のページじゃなかったらnextボっクスを表示
      const nextBoxDisplay = (pageIndex !== pageIndex_max ? 'block' : 'none');
      console.log(nextBoxDisplay)
      for (const box of nextPageBoxList) {
        box.style.display = nextBoxDisplay;
      }


      pageTargetList.forEach((page, index) => {
        page.style.display = (index === pageIndex ? 'block' : 'none');
      });
    });
  }

//フォロー
  followBtnList = document.querySelectorAll('[id^="js-followBtn-"]') ?? [];
  for (const followBtn of followBtnList) {
    followBtn.addEventListener('click', () => {
      _toggleFollow(followBtn);
    });
  }

//  共感
  let empathyBtnList = document.getElementsByClassName("js-empathyBtn") ?? [];
  for(const empathyBtn of empathyBtnList){
    empathyBtn.addEventListener('click', () => {
      console.log("empathyBtn");
      _toggleEmpathy(empathyBtn);
    });
    _serverConnect(
        (data) => {
          if (data.result) {
            empathyBtn.classList.add('isSymp');
          }
        },
        () => {},
        'get',
        getEmpathy_ep+'/'+bookcolumnId+'?fingerprint='+(new ClientJS()).getFingerprint()
    );
  }

  let favBtnList = document.getElementsByClassName("js-favBtn") ?? [];
  for(const favBtn of favBtnList){
    console.log("favBtn");
    favBtn.addEventListener('click', () => {
      _toggleFav(favBtn);
    });
  }
});
//サーバー通信
let connecting = false;
let messages = [];
const messageWrap = document.getElementById('js-errMsg');
const messageWrap_follow = document.getElementById('js-error-follow');
const messageWrap_empathy = document.getElementById('js-error-empathy');

//ページャー用
let pageTargetList = null;
let nextPageLinkList = null;
let prevPageLinkList = null;
let pageLinkList = null;
let nextPageBtnList = null;
let prevPageBtnList = null;
let nextPageBoxList = null;

//フォロー
let followBtnList = null;
//共感
let empathyBtn = null;

/**
 * Ajax 通信失敗時に起動させるメソッド
 */
const _handleError = () => {
  //通信中フラグを false にする
  connecting = false;

  //エラーを追加
  messages.push('サーバーで処理に失敗しました。再度お試し頂くか、お問い合わせ下さい。');
};
/**
 * Ajax 中断時に起動させるメソッド
 */
const _handleAbort = () => {
  //通信中フラグを false にする
  connecting = false;

  //エラーを追加
  messages.push('通信が中断されました。再度お試し下さい。');
};
/**
 * Ajax タイムアウトに起動させるメソッド
 */
const _handleTimeout = () => {
  //通信中フラグを false にする
  connecting = false;

  //エラーを追加
  messages.push('通信タイムアウトしました。ネットワーク回線を確認の上、再度お試し下さい。');
};
//サーバーと通信する部分
const _serverConnect = (onSuccess, onFail,openMethod, openUrl, sendBody = null) => {
  //通信中だったら何もしない
  if (connecting) {
    return Promise.reject();
  }

  //送信中フラグを on にする
  connecting = true;

  //非同期処理開始
  return new Promise((resolve, reject) => {
    //xhr を用意
    const xhr = new XMLHttpRequest();

    //通信失敗時
    xhr.addEventListener('error', () => {
      reject();
      _handleError();
    })
    xhr.addEventListener('timeout', () => {
      reject();
      _handleAbort();
    })
    xhr.addEventListener('abort', () => {
      reject();
      _handleTimeout();
    })

    //通信成功時処理
    xhr.addEventListener('load', event => {
      //送信中フラグを解除
      connecting = false;
      //成功・失敗のどちらでも response を JSON としてパースする
      let data = null;
          try {
            data = JSON.parse(event.target.response);
          }
          catch (e){
            console.log(e);
            messages = ['エラーが発生しました。恐れ入りますが再度お試しください。'];
            reject();
            return;
          }
      //パースに失敗
      if (data === null) {
        messages = ['サーバー情報のパースに失敗しました'];
        reject();
        return;
      }
      //失敗判定
      if (event.target.status >= 400) {
        messages = data.messages;
        onFail(data)
        reject(data.messages);
        return;
      }

      //成功したら結果を描写
      onSuccess(data);
    });

    //通信を試みる
    xhr.open(openMethod, openUrl);
    xhr.setRequestHeader('X-CSRF-Token', csrf_token)
    xhr.send(sendBody);
  });
};
//成功
function _success() {
  //成功表示用のトーストを得る
  const toast = document.querySelector('.js-successToast');

  //トーストがあれば表示
  if (toast) {
    toast.style.display = '';
    toast.classList.add('isDsply');
    setTimeout(() => { toast.classList.remove('isDsply') }, 1500);
  }
}
//失敗
function _fail() {
  if (messageWrap) {
    messageWrap.innerText = '';
    for (const msg of messages) {
      messageWrap.innerText += msg+"\n";
    }
  }
}
//失敗_follow
function _failFollow() {
  if (messageWrap_follow) {
    messageWrap_follow.innerText = '';
    for (const msg of messages) {
      messageWrap_follow.innerText += msg+"\n";
    }
  }
}
//失敗_empathy
function _failEmpathy() {
  if (messageWrap_empathy) {
    messageWrap_empathy.innerText = '';
    for (const msg of messages) {
      messageWrap_empathy.innerText += msg+"\n";
    }
  }
}

//フォローをトグル
const _toggleFollow = (btn) => {
  messages = [];
  const authorIdIndex = btn.id.lastIndexOf("-");
  const authorId = btn.id.substring(authorIdIndex + 1);
  _serverConnect((data) => {
      if (btn.classList.contains('mdFollow')) {
        btn.classList.remove('mdFollow');
      }
      else {
        btn.classList.add('mdFollow');
      }

      _success();
    },
    (data) => {
      _failFollow();
    },
    'get',
    toggleFollow_ep+'/'+authorId
  );
};

//共感をトグル
const _toggleEmpathy = (btn) => {
  messages = [];
  const bookcolumnId = btn.value;
  _serverConnect((data) => {
      _success();
    },
    (data) => {
      _failEmpathy();
    },
    'get',
    toggleEmpathy_ep+'/'+bookcolumnId+'?fingerprint='+(new ClientJS()).getFingerprint()
  );
};

const _toggleFav = (btn) => {
  messages = [];
  const bookcolumnId = btn.value;
  _serverConnect((data) => {
      _success();
    },
    (data) => {
      _fail();
    },
    'get',
    toggleFav_ep+'/'+bookcolumnId
  );
}

//以下もっと見る用の処理
document.addEventListener('DOMContentLoaded', () => {
  //もっと見るボタン・描画先
  const moreButton = document.getElementById('js-moreRelation');
  const relationsArea = document.getElementById('js-relations')

  //もっと見るボタン or 描画先が無かったらなにもしない
  if ( ! moreButton || ! relationsArea) {
    return;
  }

  //もっと見るボタンを押した時にサーバーサイドから追加の項目を読込
  moreButton.addEventListener('click', async () => {
    //サーバーサイドに要請するフェーズ・一回に要請する項目数を dataset から抜き出す
    const phase = Number(moreButton.dataset.phase) + 1;
    const limit = Number(moreButton.dataset.limit);
    const endpoint = moreButton.dataset.endpoint;

    //サーバーサイドへ要請
    try {
      //応答の取得をを試みる
      const response = await fetch(endpoint+limit+'/'+(phase * limit));

      //400 以上だったらボタンを消す
      if ( ! response.ok || response.status >= 400) {
        moreButton.parentElement.style.display = 'none';
        return;
      }

      //html の取得を試みる
      const html = await response.text();

      //html を加える
      relationsArea.innerHTML += html;

      //次回に備えフェーズを加算
      moreButton.dataset.phase = phase;

      //次回読込項目が無ければ何もしない
      if (html.indexOf('<!--more-->') === -1) {
        moreButton.parentElement.style.display = 'none';
      }
    }

      //エラー時
    catch (error) {
      console.log(error);
      moreButton.parentElement.style.display = 'none';
    }
  });
});
